/** Shared pagination defaults for Tasks page tables */

export const TASK_TABLE_DEFAULT_ROWS_PER_PAGE = 25;

/** Owner / ViewAll teams overview — show 10 rows without inner table scroll */
export const TEAMS_OVERVIEW_DEFAULT_ROWS_PER_PAGE = 10;

export const TASK_TABLE_ROWS_PER_PAGE_OPTIONS = [5, 10, 15, 20, 25, 50, 100];
